import { render, staticRenderFns } from "./QuestionTypeText.vue?vue&type=template&id=76991e95&"
import script from "./QuestionTypeText.vue?vue&type=script&lang=js&"
export * from "./QuestionTypeText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports